import { inject, Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { IAppServiceLanguages } from '@app/app.interface';
import { ILangService } from '@interfaces/lang-service.interface';
import { BehaviorSubject } from 'rxjs';

/**
 * Сервис работы с языками и переводами
 */
@Injectable()
export class LangService implements ILangService {
    readonly #config = inject(AppConfig);

    /**
     * Текущий язык
     */
    currentLanguage$ = new BehaviorSubject<string>(this.#config.defaultLanguage);

    /**
     * Описание всех доступных языков
     */
    get languages(): { [key: string]: IAppServiceLanguages } | null {
        return this.#config.languages;
    }

    /**
     * Список названий всех доступных языков
     */
    get languageNames(): string[] {
        return Object.keys(this.#config.languages);
    }

    /**
     * Количество языков
     */
    get languageCount(): number | null {
        return this.languages !== null ? Object.keys(this.languages).length : null;
    }

    /**
     * Язык по умолчанию
     */
    get defaultLanguage(): string {
        return this.#config.defaultLanguage;
    }

    /**
     * Получить текущий язык
     */
    get currentLanguage(): string {
        return this.currentLanguage$.value;
    }

    /**
     * Задать текущий язык
     * @param value Новое значение текущего языка
     */
    set currentLanguage(value: string) {
        this.currentLanguage$.next(value ?? '');
    }

    /**
     * Код текущего языка
     */
    get currentLangCode(): string | null {
        return this.languages ? this.languages[this.currentLanguage]?.code : null;
    }
}
